import { Select } from 'antd'
import styles from '../../services/styles'

const { Option } = Select
const { tc1 } = styles

export default function SL_Select(props) {
    return (
        <Select
            {...props}
            style={
                {
                    border: `1px solid ${tc1}`,
                    display: 'flex',
                    alignItems: 'center',

                    ...props.style
                }
            }
            bordered={false}
        >
            {
                props?.children?.map(
                    (option, index) =>
                        <Option {...option.props} key={index} />
                )
            }
        </Select>
    )
}